import { AnimatePresence, motion } from "framer-motion";
import { RefreshCw, Sparkles } from "lucide-react";

interface UpdateBannerProps {
  ready: boolean;
  /** Faux pendant une partie : la version attend alors un moment sûr. */
  autoApplies: boolean;
  onApply: () => void;
}

export const UpdateBanner = ({ ready, autoApplies, onApply }: UpdateBannerProps) => (
  <AnimatePresence>
    {ready && (
      <motion.div
        className="update-banner"
        role="status"
        initial={{ opacity: 0, y: 22, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 12, scale: 0.98 }}
      >
        <span className="update-banner__icon">
          {autoApplies ? (
            <RefreshCw size={17} aria-hidden="true" />
          ) : (
            <Sparkles size={17} aria-hidden="true" />
          )}
        </span>
        <span className="update-banner__copy">
          <strong>{autoApplies ? "Mise à jour…" : "Nouvelle version prête"}</strong>
          <span>
            {autoApplies
              ? "L’application redémarre dans un instant."
              : "Elle s’installera à la fin de ta partie."}
          </span>
        </span>
        {!autoApplies && (
          <button className="secondary-button secondary-button--compact" type="button" onClick={onApply}>
            Maintenant
          </button>
        )}
      </motion.div>
    )}
  </AnimatePresence>
);
